import { createClient } from "postchain-client";

import { iTypedGtxClient } from "../../interfaces/chrInterfaces";
import { backendForBestChrUrl, chromiaBlockchainRID, chromiaBlockchainUrl, useBackendForBestChrUrl } from "../../settings";
import { eChromiaActionTypes } from "../../store/chromia/chromiaTypes";
import { store } from "../../store/store";

let pendingBestChrNodePromise: Promise<string | null> | null = null;

export const getBestChrNodeUrl = async (): Promise<string | null> => {
    // 1. Если URL уже есть в сторе – используем его
    const { chrNodeUrl } = store.getState().chromia;
    if (chrNodeUrl) return chrNodeUrl;

    // 2. Если запрос уже выполняется – присоединяемся к нему
    if (pendingBestChrNodePromise) return pendingBestChrNodePromise;

    // 3. Создаём новый промис и сохраняем его
    pendingBestChrNodePromise = (async () => {
        try {
            const response = await fetch(`${backendForBestChrUrl}`);
            console.log("response:", response);
            if (response.status === 204) {
                return null;
            }

            const nodes = await response.json();
            if (!nodes || nodes.length === 0){
                return null;
            }
            const node1 = nodes[0];
            //console.log("text:", node1);
            if (node1 && node1.length>=1){
                //console.log("Best Chromia Node URL:", node1);
                store.dispatch({
                    type: eChromiaActionTypes.SET_CHR_NODE_URL,
                    payload: node1,
                });
                //console.log("text:", node1)
                return node1;
            } else {
                console.log("URL not found in response");
                return null;
            }
        } catch (error) {
            console.log("Error:", error);
            return null;
        } finally {
            // 4. После завершения (успех/ошибка) очищаем промис,
            //    чтобы при следующем вызове можно было выполнить новый запрос
            pendingBestChrNodePromise = null;
        }
    })();

    return pendingBestChrNodePromise;
};

export const getGtxClient = async (): Promise<iTypedGtxClient> => {
	const { gtxClient } = store.getState().chromia;
	
	if (gtxClient) return gtxClient;

	const nodeUrl = useBackendForBestChrUrl? await getBestChrNodeUrl() : null;

    const _directoryNodeUrlPool = nodeUrl? [nodeUrl] : chromiaBlockchainUrl;
    console.log("directoryNodeUrlPool:", _directoryNodeUrlPool);

	/* const response = await fetch(`${chromiaBlockchainUrl}brid/iid_0`);
	if (!response.ok) throw new Error();
	const rid = await response.text(); */

	const newGtxClient = (await createClient({
		nodeUrlPool: _directoryNodeUrlPool,
		// directoryNodeUrlPool: chromiaBlockchainUrl,
		blockchainRid: chromiaBlockchainRID,
		// blockchainRid: rid,
	})) as iTypedGtxClient;

	store.dispatch({
		type: eChromiaActionTypes.SET_GTX_CLIENT,
		payload: newGtxClient
	})

	return newGtxClient;
}